import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { ApiService } from "../shared/utilities/api.service";
import { Discussion, PanelMember } from "../../models";

@Injectable()
export class PanelService {
  constructor(private apiService: ApiService) {}

  public saveCredential(
    discussion: Discussion,
    panelSeat: PanelMember,
    credential: any
  ): Observable<PanelMember> {
    const discussionSlug = discussion.slug;
    const panelId = panelSeat.id;

    // PUT /api/discussions/:discussion/panels/:panelId
    const putURL = `/discussions/${discussionSlug}/panels/${panelId}`;

    return this.apiService
      .put(putURL, { panelMember: credential })
      .pipe(map((data) => data.community));
  }

  public deletePanelSeat(
    discussion: Discussion,
    panelSeat: PanelMember,
    credentials: any
  ) {
    const discussionSlug = discussion.slug;
    const panelId = panelSeat.id;

    // POST /api/discussions/:discussion/panels/delete/:panelId
    const postURL = `/discussions/${discussionSlug}/panels/delete/${panelId}`;

    return this.apiService.post(postURL, { user: credentials });
  }
}
